export default "__VITE_ASSET__01OQ$2Ah__"